import { create } from 'zustand'
import { persist } from 'zustand/middleware'

/**
 * Client-only UI state: is the dashboard sidebar collapsed.
 *
 * Zustand is ONLY for client-only global UI state. Server data never lands
 * here — that belongs to React Query.
 *
 * Note: this store persists a UI preference, not app state. The auth tokens are
 * NOT here — they are owned by `src/gateway/client.ts`.
 */
interface SidebarState {
  readonly isCollapsed: boolean
  /** Mobile/tablet off-canvas drawer — deliberately not persisted. */
  readonly isMobileOpen: boolean
  readonly toggle: () => void
  readonly setCollapsed: (collapsed: boolean) => void
  readonly openMobile: () => void
  readonly closeMobile: () => void
}

export const useSidebarStore = create<SidebarState>()(
  persist(
    (set) => ({
      isCollapsed: false,
      isMobileOpen: false,
      toggle: () => set((state) => ({ isCollapsed: !state.isCollapsed })),
      setCollapsed: (isCollapsed) => set({ isCollapsed }),
      openMobile: () => set({ isMobileOpen: true }),
      closeMobile: () => set({ isMobileOpen: false }),
    }),
    {
      name: 'turon.admin.sidebar',
      partialize: (state) => ({ isCollapsed: state.isCollapsed }),
    },
  ),
)
